
import { Path, StoreKey } from "@common/constans";
import { LoaderMode, StorageType } from "@common/enum";
import { computeNoseData, convertNodeListToElement, setMarginSeat, setNoseStyle, setStyleForSvgElement, setTailStyle } from "@misc/container/SeatMap";
import Storage from "@service/Storage";
import { createStore, Store } from "redux";
import { composeWithDevTools } from "redux-devtools-extension";
import { AppAction, IAppAction } from "./Action";
import { getInitialState, IAppState } from "./State";

const saveStateUrls = [Path.Booking.SelectFlight, Path.Booking.PaxInfo, Path.Booking.SpecialServices, Path.Booking.PrePayment];
const persistedState = window.location.pathname.includes(Path.Booking.SelectFlight) ? {} : Storage.get<IAppState>(StoreKey.ReduxState, StorageType.Session);
const initState = Object.assign(getInitialState(), persistedState);
export const store: Store<IAppState, IAppAction> = createStore(reducer, composeWithDevTools());

store.subscribe(() => {
    const lastRoute = Storage.get<string>(StoreKey.LastRoute, StorageType.Session);
    if (saveStateUrls.some((b) => window.location.pathname.includes(b)) || saveStateUrls.some((b) => lastRoute?.includes(b))) {
        const reduxStore = store.getState();
        reduxStore.preloader = {
            show: false,
            mode: LoaderMode.Blur
        };
        Storage.set<IAppState>(StoreKey.ReduxState, reduxStore, StorageType.Session);
    } else {
        Storage.remove(StoreKey.ReduxState, StorageType.Session);
    }
})

export function reducer(state: IAppState = initState, action: IAppAction): IAppState {
    switch (action.type) {
        case AppAction.CreateRealPoint:
            const mySelect = state.seatMapInitData?.data?.find((item: any) => item.type?.toLowerCase() === action.payload.seatMapRegister?.type?.toLowerCase());
            const widthCompare = state.windowWidth > 580;
            const element = action.payload.seatMapRegister?.element;
            if (!mySelect || !element)
                return { ...state };
            const target1 = mySelect.tailStartRowNumber;
            const target2 = mySelect.tailEndRowNumber;
            const seatStart = mySelect.tailStartRowNumberMargin;
            const verticalDimension = 40;
            const horizontalMargin = 0;
            const angle = mySelect.angel;
            const PI = Math.PI;
            const radianAngle = (angle * PI) / 180;
            const seatElements = document.getElementsByClassName("seat-row");
            const seatArray = convertNodeListToElement(seatElements);
            if (widthCompare)
                setMarginSeat(seatArray, verticalDimension, radianAngle, seatStart);
            if (mySelect.nose && widthCompare) {
                const seatNoseEnd = [mySelect.nose.startRowNumber, mySelect.nose.startRowNumberMargin];
                const angle = mySelect.nose.angel;
                setNoseStyle(seatArray, 22.5, angle, seatNoseEnd, mySelect.nose.topDistance)
            }
            const widthElement = window.getComputedStyle(element).width;
            const widthStr = widthElement as string;
            const width = Number(widthStr.slice(0, widthStr.length - 2));
            const [item1, item2] = [Number(target1), Number(target2)] as number[];
            const distanstOfItems = (item2 - item1) * verticalDimension;
            const realP1: [number, number] = [horizontalMargin, item1 * verticalDimension];
            const realP2: [number, number] = [horizontalMargin + distanstOfItems * Math.tan(radianAngle), item2 * verticalDimension];
            const point1 = mySelect.Point1;
            const point2 = mySelect.Point2;
            const bizierPoint = mySelect.BizierPoint;
            const dxP = Math.abs(point2[0] - point1[0]);
            const dyP = Math.abs(point2[1] - point1[1]);
            const dxb = Math.abs(bizierPoint[0] - point1[0]);
            const dyb = Math.abs(bizierPoint[1] - point1[1]);
            const dxbPercent = dxb / dxP;
            const dybPercent = dyb / dyP;
            const realPoint1 = realP1;
            const realPoint2 = realP2;
            const dprx = Math.abs(realPoint2[0] - realPoint1[0]);
            const dpry = Math.abs(realPoint2[1] - realPoint1[1]);
            const bizierRealPointX =
                bizierPoint[0] < point1[0] && bizierPoint[0] > point2[0] ? realPoint1[0] + dxbPercent * dprx : realPoint1[0] - dxbPercent * dprx;
            const bizierRealPointY = realPoint1[1] + dybPercent * dpry;
            const revertPoint1 = [width - realP1[0], realP1[1]];
            const revertPoint2 = [width - realP2[0], realP2[1]];
            const revertRealBizierPoint = [width - bizierRealPointX, bizierRealPointY];
            const avrageOfPoints = revertPoint2[0] / 2;
            const avragePoint = [avrageOfPoints, revertPoint2[1] + avrageOfPoints * 0.75];
            setStyleForSvgElement("svg", widthElement, realP2[1]);
            const widthTail2 = revertPoint2[0] - realPoint2[0];
            setTailStyle(widthTail2, realPoint2[1]);
            const noseMap = mySelect.nose ? mySelect.nose : false;
            const noseData = noseMap ?
                computeNoseData(verticalDimension, width, noseMap.startRowNumber, noseMap.bizierPoint, [noseMap.point1, noseMap.point2]) : 0;

            return {
                ...state,
                seatMapInitData: {
                    ...state.seatMapInitData,
                    SVGPoint: {
                        width: width,
                        pointStart: [0, 0],
                        pointEnd: [width, 0],
                        point1: realP1,
                        point2: realP2,
                        revertPoint1: revertPoint1,
                        revertPoint2: revertPoint2,
                        realBizierPoint: [bizierRealPointX, bizierRealPointY],
                        revertRealBizierPoint: revertRealBizierPoint,
                        avragePoint: avragePoint,
                    },
                    noseData
                }
            };
        case AppAction.CurrentStep:
            Storage.set(StoreKey.CurrentStep, action.payload.currentStep, StorageType.Session);
            return { ...state, ...action.payload };
        default:
            return { ...state, ...action.payload };
    }

}